import React, { FC, memo, useCallback } from 'react'
import { Slider } from '@wmgtech/legato'

import { useBrowserNotifications } from 'modulesCommon/serviceHooks'

import styles from './BrowserNotificationSection.module.scss'

export const BrowserNotificationSection: FC = memo(() => {
  const { notificationsData, toggleSubscription } = useBrowserNotifications()
  const { userId, status } = notificationsData[0]

  const toggleSubscriptionHandler = useCallback((e) => toggleSubscription(e, userId), [userId, toggleSubscription])

  return (
    <div>
      <div className={styles.slider}>
        <h4>Browser Push Notification</h4>
        <Slider
          colorTypeOff="info"
          colorTypeOn="primary"
          size="xs"
          onChange={toggleSubscriptionHandler}
          checked={!!status}
        />
      </div>
      <div className={styles.notes}>
        You'll receive notifications when new stories are published, even when you're not on Storybox.
      </div>
    </div>
  )
})
